import {
  Avatar,
  AvatarGroup,
  Box,
  Button,
  Divider,
  Grid2,
  Typography,
  Pagination,
  Card,
  CardContent,
  TextField,
  InputBase,
  InputAdornment,
  Autocomplete,
  Breadcrumbs,
  Paper,
  Stack,
  Chip,
  CircularProgress
} from "@mui/material";
import { TimelineDot } from "@mui/lab";
import SearchIcon from "@mui/icons-material/Search";
import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined';
import ReplyOutlinedIcon from '@mui/icons-material/ReplyOutlined';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import BookmarkBorderOutlinedIcon from '@mui/icons-material/BookmarkBorderOutlined';




import React, { useState, useEffect, useRef, useMemo } from "react";
import { ReactComponent as PlusIcon } from "Assets/Icons/Settings/PlusIcon.svg";
import { ReactComponent as FileIcon } from "Assets/Icons/Discussion/FileIcon.svg";
import PrimaryIcon from "Components/Common/PrimaryIcon";
import CommonWrapper from "Components/Common/CommonWrapper";
import AddIcon from '@mui/icons-material/Add';
import { useDispatch, useSelector } from "react-redux";
import { getDiscussionTags, getDiscussionTopics, getTopicPosts, getPost, getPostDetails, postBookmark, postShare } from "Slices/thunks";
import ReplyDialog from "Components/Discussion/ReplyDialog";
import PostDialog from "Components/Discussion/PostDialog";
import ShareDialog from "Components/Discussion/ShareDialog";
import Post from "Components/Discussion/Post";
import Loader from "Components/Common/Loader";
import { useParams } from "react-router-dom";

const styles = (theme) => ({
  display: "flex",
  flexDirection: "column",
  gap: "16px",
  minHeight: "100vh",
  "& .discussionBox": {
    borderRadius: "8px",
    border: `1px solid ${theme.palette.border.blue}`,
    background: theme.palette.white.main,
    "& .header": {
      padding: "8px",
      // background: theme.palette.background.default,
    },
    "& .body": {
      "&>div": {
        padding: "8px",
      },
    },
  },
  "& .pagination": {
    '& .MuiPaginationItem-root': {
      bgcolor: theme.palette.background.default,
      color: theme.palette.primary.main,
      border: "none"
    },
    '& .Mui-selected': {
      bgcolor: theme.palette.primary.main,
      color: theme.palette.white.main,
      fontWeight: "bold"
    }
  },
  '& .breadcrumb': {
    fontSize: "14px",
    color: theme.palette.secondary.light,
    '&:hover': {
      color: theme.palette.primary.main,
    },
  },
  '& .selected': {
    color: theme.palette.primary.main,
  }
});

const Discussions = () => {
  const dispatch = useDispatch();
  const { encryptPostId, encryptUserId } = useParams();
  const [filter, setFilter] = useState({ TopicID: "", TagID: "", Status: "", Search: "" });
  const [currentTab, setCurrentTab] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [post, setPost] = useState({});
  const [topic, setTopic] = useState({});
  const [openPost, setOpenPost] = useState(false);
  const [openReply, setOpenReply] = useState(false);
   const [openShare, setOpenShare] = useState(false);

  const timeoutRef = useRef(null);
  
  const { Profile, Tags, Topics, isTopicLoading, TopicPosts, SuggestedPosts, Posts, isPostLoading, PostDetails, isPostDetails, Translation } = useSelector((state) => ({
    Profile: state.Profile.profile,
    Tags: state.DiscussionHub.tags,
    Topics: state.DiscussionHub.topics,
    TopicPosts: state.DiscussionHub.topicPosts,
    isTopicLoading: state.DiscussionHub.isTopicLoading,
    SuggestedPosts: state.DiscussionHub.suggestedPosts,
    Posts: state.DiscussionHub.posts || [],
    isPostLoading: state.DiscussionHub.isPostLoading,
    PostDetails: state.DiscussionHub.postDetails || {},
    isPostDetails: state.DiscussionHub.isPostDetails,
    Translation: state.Translation.translation?.DiscussionHub || {},
  }));

  const menu = useMemo(() => {
    return [
      {Label: Translation?.Latest, Value: 'Latest'},
      {Label: Translation?.Bookmarks, Value: 'Bookmarks'},
      {Label: Translation?.New, Value: 'New'},
      {Label: Translation?.Unread, Value: 'Unread'},
      {Label: Translation?.Top, Value: 'Top'},
      {Label: Translation?.InterviewExperiences, Value: 'Interview Experiences'}
    ]

  }, [Translation])

  function getTimeDifferenceText(dateStr) {
    const now = new Date();
    const past = new Date(dateStr);
    const diff = now - past;

    const seconds = Math.floor(diff / 1000);
    const minutes = Math.floor(diff / (1000 * 60));
    const hours = Math.floor(diff / (1000 * 60 * 60));
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const months = Math.floor(days / 30);
    const years = Math.floor(days / 365);

    if (years > 0) return `${years} year${years > 1 ? 's' : ''}`;
    if (months > 0) return `${months} month${months > 1 ? 's' : ''}`;
    if (days > 0) return `${days} day${days > 1 ? 's' : ''}`;
    if (hours > 0) return `${hours} hour${hours > 1 ? 's' : ''}`;
    if (minutes > 0) return `${minutes} minute${minutes > 1 ? 's' : ''}`;
    return `${seconds} second${seconds > 1 ? 's' : ''}`;
  }

  const handleFilter = (name, value, topic = Translation.AllTopics) => {

    const data = {
      ...filter,
      Topic: topic,
      [name]: value
    }

    dispatch(getPost(data));
    setFilter(data);
    setCurrentTab(2);
  };

  const handleSearch = (e) => {
    const value = e.target.value?.trim();
    const data = {
      TopicID: "", 
      TagID: "", 
      Status: "", 
      Search: value 
    }
    setFilter(data);

    // Clear previous timeout if user is still typing
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    if (value) {
      timeoutRef.current = setTimeout(() => {
        dispatch(getPost(data));
        setCurrentTab(2);
      }, 1000);
    } else {
      // dispatch(getPost(data));
      setCurrentTab(1);
    }
  }

  const handlePageChange = (e, p) => {
    setCurrentPage(p);
  }

  const handleReadMore = (p) => {

    dispatch(getPost({ TopicID: p.TopicID }))
    setPost(p);
    setFilter({TopicID: p.Topic});
    setTopic({TopicID: p.TopicID, Topic: p.Topic});
    setCurrentTab(2);
  }

  const handleViewMore = (p) => {
    dispatch(getPostDetails({PostID: p.ID}));
    setPost(p);
    setTopic({TopicID: p.TopicID, Topic: p.Topic});
    setCurrentTab(3);
  }

  const handleAllTopics = () => {
    dispatch(getTopicPosts())
    setFilter({TopicID: "", TagID: "", Status: ""})
    setCurrentTab(1);
  }

  const handleTopic = () => {
    dispatch(getPost({ TopicID: topic.TopicID }))
    setCurrentTab(2);
  }

  const handleBookmark = () => {
    dispatch(postBookmark({PostID: post.ID}))
  }

  useEffect(() => {
    dispatch(getTopicPosts());
    dispatch(getDiscussionTags());
    dispatch(getDiscussionTopics());

    if (encryptPostId && encryptUserId) {
      dispatch(postShare({PostID: atob(encryptPostId), UserID: atob(encryptUserId)}))
      // dispatch(getPostDetails({PostID: atob(encryptPostId)}));
    }

  }, [])

  return (
    <CommonWrapper width="lg"> 
      { isTopicLoading ? <Loader /> :
          <Grid2 sx={styles}>

            {/* Filter & Search */}
            { [1, 2].includes(currentTab) && <>
              <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 1 }}>
                <Autocomplete
                  value={[{ ID: "", Name: Translation?.AllTopics }, ...(Topics || [])].find((item) => item.ID == filter?.TopicID)}
                  onChange={(event, newValue) => {
                    handleFilter("TopicID", newValue?.ID, newValue?.Name)
                  }}
                  options={[{ ID: "", Name: Translation?.AllTopics }, ...(Topics || [])]}
                  autoHighlight
                  getOptionLabel={(option) => option.Name}
                  clearIcon={false}
                  noOptionsText={<Typography>{Translation?.NoResultsFound}</Typography>}
                  renderOption={(props, option) => {
                    const { key, ...optionProps } = props;
                    return (
                      <Typography key={key} {...optionProps}>
                        {option?.Name}
                      </Typography>
                    );
                  }}
                  sx={{ width: 200 }}
                  renderInput={(params) => (
                    <TextField {...params} label={Translation?.Topics} size="small" />
                  )}
                />

                {/* 2. Searchable Dropdown for Types */}
                <Autocomplete
                  value={[{ ID: "", Name: Translation?.AllTags }, ...(Tags || [])].find((item) => item.ID == filter?.TagID)}
                  onChange={(event, newValue) => {
                    handleFilter("TagID", newValue?.ID)
                  }}
                  options={[{ ID: "", Name: Translation?.AllTags }, ...(Tags || [])]}
                  autoHighlight
                  getOptionLabel={(option) => option.Name}
                  clearIcon={false}
                  noOptionsText={<Typography>{Translation?.NoResultsFound}</Typography>}
                  renderOption={(props, option) => {
                    const { key, ...optionProps } = props;
                    return (
                      <Typography key={key} {...optionProps}>
                        {option?.Name}
                      </Typography>
                    );
                  }}
                  sx={{ width: 200 }}
                  renderInput={(params) => (
                    <TextField {...params} label={Translation?.Tags} size="small" />
                  )}
                />

                {menu.map((item, index) => (
                  <Button variant="text" color={filter.Status === item.Value ? "primary" : "secondary"} sx={{textTransform: 'none'}} onClick={(e) => handleFilter("Status", item.Value)}>
                  {item.Label}
                  </Button>
                ))}
              </Box>

              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: {xs: '100%', md: 'auto'}, justifyContent: 'flex-end !important' }}>
                {/* <InputBase
                  placeholder={Translation?.SearchForTopicTrendsInsights}
                  startAdornment={<SearchIcon fontSize="small" sx={{color: 'secondary.light', mr: 0.5}}/>}
                  sx={(theme) => ({ 
                    borderRadius: '8px', 
                    border: `1px solid ${theme.palette.border.grey}`,
                    fontSize: '0.875rem',
                    px: '12px',
                    py: '3px', 
                    flexGrow: {xs: 1, md: 0},
                    minWidth: { md: 300, lg: 380},
                  })}
                /> */}
                <TextField
                  onChange={handleSearch}
                  name="Search"
                  size="small"
                  value={filter?.Search}
                  sx={{minWidth: { md: 250, lg: 300}}}
                  placeholder={Translation?.SearchForTopicTrendsInsights}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon fontSize="small" />
                      </InputAdornment>
                    ),
                  }}
                />
                <Button variant="contained" startIcon={<AddIcon />} onClick={() => setOpenPost(true)}>
                  {Translation?.NewPost}
                </Button>
              </Box>
            </> }

            { currentTab === 1 ? <>
                {/* Topic Cards */}
                <Grid2 container spacing={2} mb={3}>
                  {TopicPosts?.slice((currentPage - 1) * 8, currentPage * 8).map((item, i) => (
                    <Grid2 item sm={4} md={3} key={i} size={3} display={"flex"} alignItems={"center"}>
                      <Card sx={{ borderRadius: "8px", minHeight: 160 }}>
                        <CardContent display={"flex"} gap="8px">
                          <Box display={"flex"} mb={2}>
                            <PrimaryIcon
                              icon={FileIcon}
                              height="32px"
                              width="32px"
                            />
                          </Box>
                          <Box display={"flex"} justifyContent={"space-between"}>
                            <Typography variant="body" fontSize={"14px"} fontWeight={500} color="secondary.light">
                                {Translation?.AllTimePosts}
                            </Typography>
                            <Typography variant="body" fontSize={"14px"} fontWeight={500} color="secondary.light">
                              {item?.TotalPosts}
                            </Typography>
                          </Box>
                          <Box display={"flex"} justifyContent={"space-between"}>
                            <Typography variant="body" fontSize={"14px"} fontWeight={500} color="secondary.light">
                                {Translation?.TotalReplies}
                            </Typography>
                            <Typography variant="body" fontSize={"14px"} fontWeight={500} color="secondary.light">
                              {item?.TotalReplies}
                            </Typography>
                          </Box>
                          <Typography variant="subtitle2" fontSize={"16px"} fontWeight={650} mt={2}>
                            {item?.Topic}
                          </Typography>
                          <Typography variant="body2" color="secondary.light" fontSize={"12px"}>
                            {item?.Description}
                          </Typography>
                          
                          <Button size="small" sx={{ mt: 1 }} onClick={() => handleReadMore(item)}>
                            {Translation?.ReadMore}
                          </Button>
                        </CardContent>
                      </Card>
                    </Grid2>
                    ))}
                </Grid2>
                
                {/* Pagination */}
                <Box display="flex" justifyContent="center" mb={3}>
                  <Pagination className="pagination" count={Math.ceil((TopicPosts?.length || 0) / 8)} page={currentPage} color="primary" variant="outlined" shape="rounded" onChange={handlePageChange} />
                </Box>
              </> :

              currentTab === 2 ? <>
                { isPostLoading ? <Grid2 container display={"flex"} justifyContent={"center"} my={2}>
                    <CircularProgress />
                  </Grid2> :
                  Array.isArray(Posts) && Posts.length > 0 ? <>
                  <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb" sx={{ mb: 2, color: 'secondary.light' }}>
                    <Button className="breadcrumb" variant="text" fontSize={"14px"} onClick={handleAllTopics}>{Translation?.AllTopics}</Button>
                    <Button className="breadcrumb selected" variant="text" fontSize={"14px"} onClick={handleTopic}>{topic?.Topic}</Button>
                  </Breadcrumbs>

                  <Grid2
                    container
                    spacing={2}
                    columns={{ lg: 12, xl: 12, md: 9, sm: 6, xs: 3 }}
                  >
                    {Posts?.map((item, i) => {
                      return (
                        <Grid2 className="discussionBox" key={i} size={3}>
                          <Box className="header">
                            <Typography variant="title" fontWeight={600}>
                              {item?.Title}
                            </Typography>
                            <Box display={"flex"} flexDirection={"row"} gap="8px">
                              {Array.isArray(item.Tags) && item.Tags.map((item) => {
                                return (
                                  <>
                                    <TimelineDot sx={{ margin: "auto 7px", color: `${item?.ColorCode} !important` }} />
                                    <Typography variant="subtitle" fontWeight={500}>
                                      {item.Tag}
                                    </Typography>
                                  </>
                                )
                              })}
                            </Box>
                          </Box>
                          <Box className="body">
                            <Box display={"flex"} justifyContent={"space-between"}>
                              <Typography color="secondary.light">{Translation?.Replies} - {item?.Replies}</Typography>
                              <Divider flexItem orientation="vertical" />
                              <Typography color="secondary.light">{Translation?.View} - {item?.Views}</Typography>
                              { item?.LastActivity && <>
                                <Divider flexItem orientation="vertical" />{" "}
                                <Typography color="secondary.light"> 
                                  {Translation?.Activity} - {getTimeDifferenceText(item?.LastActivity)}
                                </Typography>
                              </>

                              }
                              <Divider orientation="vertical" />
                            </Box>
                            <Divider />
                            <Box display={"flex"} justifyContent={"space-between"}>
                              <AvatarGroup spacing="medium">
                                { item.ReplyUserPics.map((pic) => {
                                  return (
                                    <Avatar
                                      sx={{ width: 24, border: "none !important", height: 24 }}
                                      alt="Remy Sharp"
                                      src={pic}
                                    >
                                      S
                                    </Avatar>
                                  )
                                })
                                }

                              </AvatarGroup>

                              <Button variant="outlined" color="secondary" size="small" onClick={() => handleViewMore(item)}>
                                {Translation?.ViewMore}
                              </Button>
                            </Box>
                          </Box>
                        </Grid2>
                      );
                    })}
                  </Grid2>
                  </> :
                  <Grid2 container display={"flex"} justifyContent={"center"} my={2}>
                    <Typography alignItems={"center"} variant="h6">{Translation?.NoPostsAvailable}</Typography>
                  </Grid2>
                }

              </> :
              
              currentTab === 3 ? <>
                { isPostDetails ?
                  <Grid2 container display={"flex"} justifyContent={"center"} my={2}>
                    <CircularProgress />
                  </Grid2> : <>
                    {/* Breadcrumbs */}
                    <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb" sx={{ mb: 2, color: 'secondary.light' }}>
                      {/* <Typography sx={{ fontSize: '0.875rem' }}>All Topics</Typography>
                      <Typography sx={{ fontSize: '0.875rem' }}>General</Typography>
                      <Typography sx={{ fontSize: '0.875rem', color: 'text.primary' }}>Post</Typography> */}

                      <Button className="breadcrumb" variant="text" fontSize={"14px"} onClick={handleAllTopics}>{Translation?.AllTopics}</Button>
                      <Button className="breadcrumb" variant="text" fontSize={"14px"} onClick={handleTopic}>{topic?.Topic}</Button>
                      <Button className="breadcrumb selected" variant="text" fontSize={"14px"}>{Translation?.Post}</Button>
                    </Breadcrumbs>
            
                    {/* Main Post Section */}
                    <Paper elevation={0} sx={{ borderRadius: '16px', bgcolor: 'white' }}>
                      <Box sx={{ mb: 3 }}>
                        <Typography variant="h5" component="h1" sx={{ fontWeight: 'bold', mb: 1.5 }}>
                          {/* Why isnt option D wrong along with option A? */}
                          {post?.Title}
                        </Typography>
                        <Stack direction="row" spacing={1}>
                          {Array.isArray(post?.Tags) && post?.Tags?.map((item) => {
                            return (
                              <Chip label={item.Tag} size="small" sx={{ bgcolor: item.BgColorCode, color: item.ColorCode, fontWeight: 'medium', borderRadius: '4px' }} />
                            )
                          })}

                          {/* <Chip label="Academy" size="small" sx={{ bgcolor: '#fce8e6', color: '#c5221f', fontWeight: 'medium', borderRadius: '4px' }} />
                          <Chip label="General" size="small" sx={{ bgcolor: '#e8f0fe', color: '#1967d2', fontWeight: 'medium', borderRadius: '4px' }} />
                          <Chip label="split-the-difference" size="small" sx={{ bgcolor: '#f1f3f4', color: '#3c4043', fontWeight: 'medium', borderRadius: '4px' }} /> */}
                        </Stack>
                      </Box>
          
                      <Box sx={(theme) => ({bgcolor: theme.palette.background.default, p: 2, borderRadius: "8px"})}>
                        <Post data={PostDetails?.PostUser} post={post} setOpenReply={setOpenReply} setOpenShare={setOpenShare} />
          
                        { Array.isArray(PostDetails?.Replies) && PostDetails?.Replies.map((reply) => {
                          return (
                            <Box sx={{ my: 3, ml: '56px' /* Avatar width (40px) + gap (16px) */ }}>
                              <Post data={reply} post={post} isReply />
                            </Box>
                          )
                        }) }
                        
                        <Box sx={{ mt: 3, display: 'flex', alignItems: 'center', gap: 1, borderTop: '1px solid #e8eaed', pt: 2, flexWrap: 'wrap' }}>
                          <Button variant="contained" startIcon={<ShareOutlinedIcon />} sx={{ bgcolor: '#1a73e8', textTransform: 'none', borderRadius: '20px', boxShadow: 'none' }}>
                            {Translation?.Share}
                          </Button>
                          <Button variant="text" startIcon={<ReplyOutlinedIcon />} sx={{ textTransform: 'none', color: 'secondary.light' }} onClick={() => setOpenReply(true)}>
                            {Translation?.Reply}
                          </Button>
                          <Button variant="text" startIcon={<BookmarkBorderOutlinedIcon />} sx={{ textTransform: 'none', color: PostDetails?.PostUser?.Interactions?.Bookmark ? 'primary.main' : 'secondary.light' }} onClick={handleBookmark}>
                            {Translation?.Bookmark}
                          </Button>
                        </Box>
                      </Box>
          
                    </Paper>
                  </>
                }

      
              </> : <></>
            }


            { [1, 3].includes(currentTab) && <>
              <Typography variant="title" fontWeight="bold" mb={1}>
                {Translation?.SuggestedPosts}
              </Typography>

              <Grid2
                container
                spacing={2}
                columns={{ lg: 12, xl: 12, md: 9, sm: 6, xs: 3 }}
              >
                {SuggestedPosts?.map((item, i) => {
                  return (
                    <Grid2 className="discussionBox" key={i} size={3}>
                      <Box className="header">
                        <Typography variant="title" fontWeight={600}>
                          {item?.Title}
                        </Typography>
                        <Box display={"flex"} flexDirection={"row"} gap="8px">
                          {Array.isArray(item.Tags) && item.Tags.map((item) => {
                            return (
                              <>
                                <TimelineDot sx={{ margin: "auto 7px", color: `${item?.ColorCode} !important` }} />
                                <Typography variant="subtitle" fontWeight={500}>
                                  {item.Tag}
                                </Typography>
                              </>
                            )
                          })}
                        </Box>
                      </Box>
                      <Box className="body">
                        <Box display={"flex"} justifyContent={"space-between"}>
                          <Typography color="secondary.light">{Translation?.Replies} - {item?.Replies}</Typography>
                          <Divider flexItem orientation="vertical" />
                          <Typography color="secondary.light">{Translation?.View} - {item?.Views}</Typography>
                          { item?.LastActivity && <>
                            <Divider flexItem orientation="vertical" />{" "}
                            <Typography color="secondary.light"> 
                              {Translation?.Activity} - {getTimeDifferenceText(item?.LastActivity)}
                            </Typography>
                          </>

                          }
                          <Divider orientation="vertical" />
                        </Box>
                        <Divider />
                        <Box display={"flex"} justifyContent={"space-between"}>
                          <AvatarGroup spacing="medium">
                            { item.ReplyUserPics.map((pic) => {
                              return (
                                <Avatar
                                  sx={{ width: 24, border: "none !important", height: 24 }}
                                  alt="Remy Sharp"
                                  src={pic}
                                >
                                  S
                                </Avatar>
                              )
                            })
                            }

                          </AvatarGroup>

                          <Button variant="outlined" color="secondary" size="small" onClick={() => handleViewMore(item)}>
                            {Translation?.ViewMore}
                          </Button>
                        </Box>
                      </Box>
                    </Grid2>
                  );
                })}
              </Grid2>
            </>
            }
          </Grid2>
      }

      <PostDialog open={openPost} setOpen={setOpenPost} /> 
      <ReplyDialog open={openReply} setOpen={setOpenReply} post={post} /> 
      <ShareDialog open={openShare} setOpen={setOpenShare} shareLink={`${window.location.origin}/discussion-hub/${btoa(post?.ID)}/${btoa(Profile?.UserId)}`} /> 
    </CommonWrapper>
  );
};

export default Discussions;
